import { render, staticRenderFns } from "./textAlign-editor.vue?vue&type=template&id=020abc85&scoped=true&"
import script from "./textAlign-editor.vue?vue&type=script&lang=js&"
export * from "./textAlign-editor.vue?vue&type=script&lang=js&"
import style0 from "./textAlign-editor.vue?vue&type=style&index=0&id=020abc85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020abc85",
  null
  
)

export default component.exports